import IconDoubleChevronLeft from '@apollo/icons/default/IconDoubleChevronLeft.svg';
import IconDoubleChevronRight from '@apollo/icons/default/IconDoubleChevronRight.svg';
import { IconButton } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

interface Props
  extends Pick<
    React.ComponentProps<typeof IconButton>,
    'onClick' | 'className'
  > {
  /**
   * If the docs button is toggled on or not
   */
  on: boolean;
}

/**
 * Button to toggle the docs being shown or not
 */
export const DocsToggle = ({ on, ...props }: Props) => {
  return (
    <Tooltip label={on ? 'Collapse' : 'Expand'}>
      <IconButton
        data-testid="toggle-docs-expand"
        aria-label={on ? 'Collapse Docs' : 'Expand Docs'}
        variant="hidden"
        size="sm"
        icon={on ? <IconDoubleChevronLeft /> : <IconDoubleChevronRight />}
        {...props}
      />
    </Tooltip>
  );
};
